import {
  Box,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Button from "components/Button";
import classNames from "classnames";
import DialogBox from "components/DialogBox";
import { useContext, useState } from "react";

import { TourContext } from "contexts/TourContext";
import {
  closeBtnStyle,
  popupContainer,

} from "./ProductStyles";

import ProductsBox from "./components/ProductsBox";

interface ProductModalInterface {
  readonly openProductsModal: boolean;
 readonly changeWidthProp? : boolean
}

export const ProductsModal: React.FC<ProductModalInterface> = ({
  openProductsModal,
  changeWidthProp
}) => {





  const { handleOpenSignUpModal, handleCloseProductsModal } =
    useContext(TourContext);

  return (
    <DialogBox
      isModalOpen={openProductsModal}
      handleModalClose={handleCloseProductsModal}
      width="1200px"
      height="650px"
      styles={popupContainer}
      showLogo={false}
      closeIconStyles={closeBtnStyle}
      content={
<ProductsBox changeWidthProp = {changeWidthProp}/>
      }
    ></DialogBox>
  );
};
